module.exports = __webpack_public_path__ + "static/media/women-fas-cat-8.85fb6975.png";